import addDaysToSchedule from "./addDaysToSchedule.ts";
import doAwards from "./doAwards.ts";
import genPlayoffSeeds from "./genPlayoffSeeds.ts";
import genPlayoffSeries from "./genPlayoffSeries.ts";
import getAwardCandidates from "./getAwardCandidates.ts";
import getDaysLeftSchedule from "./getDaysLeftSchedule.ts";
import getInitialNumGamesConfDivSettings from "./getInitialNumGamesConfDivSettings.ts";
import getLeaderRequirements from "./getLeaderRequirements.ts";
import { getNumPlayoffByes } from "./getNumPlayoffByes.ts";
import getNumPlayoffTeams from "./getNumPlayoffTeams.ts";
import getPlayoffsByConf from "./getPlayoffsByConf.ts";
import getSchedule from "./getSchedule.ts";
import getSeasonLeaders from "./getSeasonLeaders.ts";
import hasTies from "./hasTies.ts";
import newSchedule from "./newSchedule.ts";
import newSchedulePlayoffsDay from "./newSchedulePlayoffsDay.ts";
import setSchedule from "./setSchedule.ts";
import updateOwnerMood from "./updateOwnerMood.ts";
import validatePlayoffSettings from "./validatePlayoffSettings.ts";

export default {
	addDaysToSchedule,
	doAwards,
	genPlayoffSeeds,
	genPlayoffSeries,
	getAwardCandidates,
	getDaysLeftSchedule,
	getInitialNumGamesConfDivSettings,
	getLeaderRequirements,
	getNumPlayoffByes,
	getNumPlayoffTeams,
	getPlayoffsByConf,
	getSchedule,
	getSeasonLeaders,
	hasTies,
	newSchedule,
	newSchedulePlayoffsDay,
	setSchedule,
	updateOwnerMood,
	validatePlayoffSettings,
};
